import { gql } from '@apollo/client';

export const GET_ALL_ECD_REGISTRATION_PHOTOS = gql`
  query getAllEcdAnswersPhotos($id: ID!) {
    files: getAllEcdAnswersPhotos(id: $id) {
      id
      url
      name
    }
  }
`;
